import axios from '../../api/diagnosisAPI';
import { setErrorNotification } from '../snackbarNotification';

export const FETCH_BEGIN = 'animalCategory.list/FETCH_BEGIN';
export const FETCH_SUCCESS = 'animalCategory.list/FETCH_SUCCESS';
export const FETCH_FAILED = 'animalCategory.list/FETCH_FAILED';

const fetchBegin = () => ({ type: FETCH_BEGIN });
const fetchSuccess = (data) => ({ type: FETCH_SUCCESS, payload: data });
const fetchFailed = (error) => ({ type: FETCH_FAILED, payload: error });
export const fetchAnimalCategoryList = () => async (dispatch) => {
  dispatch(fetchBegin());
  
  try {
    const res = await axios.get('retrieve-animal-category');

    dispatch(fetchSuccess(res.data.result));
  } catch(error) {
    dispatch(fetchFailed(error.toString()));
    dispatch(setErrorNotification(error.toString()))
  }
}

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch(type) {
    case FETCH_BEGIN:
      return { ...state, error: null };
    case FETCH_SUCCESS:
      return { ...state, data: payload };
    case FETCH_FAILED:
      return { ...state, error: payload };

    default:
      return state;
  }
}

const initialState = {
  data: [],
  error: null
}

const DUMMY_ANIMAL_CATEGORY_LIST = [
  { id: 1, name: "Mammal" },
  { id: 2, name: "Bird" },
  { id: 3, name: "Reptile" },
  { id: 4, name: "Fish" },
]